import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { ApiConnectionString } from '../../constants/ApiConntection';
import LoadingSpinner from '../../components/LoadingSpinner';
import { useAuthContext } from '../../hooks/useAuthContext';
import ProfilePlaceHolder from "../../assets/ProfilePlaceHolder.png"
import NoImagePlaceholder from "../../assets/NoImagePlaceholder.png"
import { useNavigate } from 'react-router-dom';
//stlyed
export default function UserSubscribedToYourClub({notification}) {
  const [product,setProduct] = useState(null);
  const [profile,setProfile] = useState(null)
  const [club,setClub] = useState(null)
const navi = useNavigate()


  const [isLoading,setIsLoading] = useState(true)
  const {user} = useAuthContext()

  

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const productResponse = await axios.get(`${ApiConnectionString}/api/product/${notification.productId}`);
      if (productResponse.status === 200) {
        setProduct(productResponse.data);
      }
  
      const clubResponse = await axios.get(`${ApiConnectionString}/api/club/${notification.clubId}`);
      if (clubResponse.status === 200) {
        setClub(clubResponse.data);
      
      }

      const profileReponse = await axios.get(`${ApiConnectionString}/api/BookingProfile/${notification.bookingProfileId}`, {
        headers: { Authorization: `Bearer ${user.token}` },
    });
    if(profileReponse.status == 200){
      setProfile(profileReponse.data)
    }
    } catch (error) {
      console.error('Error fetching data:', error);
      // Handle the error as needed, e.g., showing an error message
    } finally {
      setIsLoading(false);  // This will stop the loading indicator
    }
  };

  useEffect(() => {
  
 fetchData()
  },[user])

  if(isLoading){
    return (
      <div className='container'>
      <LoadingSpinner />
  
            </div>
    )
  }
  else{

    if(club && product && profile){
      return (
        <div className="container text-center bg-white">
          <div className="blueBanner mt-2">
            <p className=" fw-bold p-2">Subscription Canceled</p>
          </div>

          <p>{notification.content}</p>
          <div className="row">
            <div className="col">
              <div className="lightBlueBanner">
                <p className="fw-bold p-2">Club</p>
              </div>
              <p
                onClick={() => navi(`/myoneclub/${club.id}`)}
                className="fw-bold red-text pointer"
              >
                {club.name}
              </p>
              <div
                onClick={() => navi(`/myoneclub/${club.id}`)}
                className="circle-crop mx-auto"
              >
                <img
                  src={
                    club.image
                      ? `${ApiConnectionString}/api/ClubProfileImage/${club.id}`
                      : NoImagePlaceholder
                  }
                  alt="Club Image"
                  className="mt-0 pointer"
                />{" "}
              </div>
            </div>
            <div className="col">
              <div className="lightBlueBanner">
                <p className="fw-bold p-2">Subscription</p>
              </div>
              <table className="custom-table">
                <thead className="blueBanner">
                  <tr>
                    <th>Name</th>
                    <th>Description</th>
                    <th>interval</th>
                    <th>Cost</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{product.name}</td>
                    <td>{product.description}</td> <td>{product.interval}</td>{" "}
                    <td>{product.price}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="lightBlueBanner mt-2">
            <p className="fw-bold p-2">Profile</p>
          </div>

          <div className="d-flex justify-content-center">
            <div className="bg-white d-flex justify-content-center profileBox rounded shadow mt-3">
              <div>
                <img
                  src={
                    profile.image
                      ? `${ApiConnectionString}/api/profileImage/${profile.id}`
                      : ProfilePlaceHolder
                  }
                  alt="Profile Image"
                  width={200}
                  className=" m-3 circle-crop"
                />
              </div>

              <div className="mx-5 mt-5">
                <p className="red-text">Username</p>
                <p className="fw-bold mt-2">{profile.username}</p>
              </div>
              <div className="mx-5 mt-5">
                <p className="red-text">Name</p>
                <p className="fw-bold">
                  {profile.firstName + " " + profile.lastName}
                </p>
              </div>
            </div>
          </div>
        </div>
      );
    }else{
      return(
        <div className="container text-center bg-white">
        <div className="blueBanner mt-2">
          <p className=" fw-bold p-2">Subscription Canceled</p>
        </div>
          <p>Not Found</p>
        </div>
      )
    }
    
  
  }

}
